import * as React from 'react';
import useDateRangeFilter, { DateRangeOptions } from 'src/share/hooks/useDateRangeFilter';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { RoutesModules } from 'src/modules/Routing/types';
import routes from 'src/modules/Routing/routes';
import { ISearch } from 'src/share/types/search';
import useLogs from './hooks/useLogs';
import { capitalize } from 'src/share/utils/utils';
import LogsTable from './components/LogsTable';
import './logs.css'

const initialSearch: ISearch = { size: 10, page: 0, queryString: "", sort: [{ date: { order: 'desc' }}]};

function Logs(props): React.ReactElement {
  const logsType = props.match.path === routes.LOGINLOGS ? "login" : "audit";
  const [search, setSearch] = React.useState<ISearch>(initialSearch);
  const [dateRange, setDateRange] = useDateRangeFilter();
  const [logs, total, isLoading] = useLogs(search, dateRange, logsType);
  function handleSearched(text: string): void {
    setSearch(prevSearch => ({ ...prevSearch, queryString: text }));
  }
  function handleDateChanged(date): void {
    setDateRange({ type: DateRangeOptions.SET_DATES, payload: date });
  }
  function handleFocusChanged({ focus }): void {
    setDateRange({ type: DateRangeOptions.SET_FOCUS, payload: focus });
  }
  function handleSorted(column, sortDirection): void {
    setSearch(prevSearch => ({ ...prevSearch, sort: [{ [column.selector]: sortDirection }] }));
  }
  function handleSizeChanged(size, page): void {
    setSearch(prevSearch => ({ ...prevSearch, size, page: page - 1 }))
  }
  function handlePageChanged(page): void {
    setSearch(prevSearch => ({ ...prevSearch, page: page - 1 }));
  }
  return (
    <div className="logs__container white-background">
      <h1>{capitalize(logsType)} Logs</h1>
      <LogsTable 
        logs={logs}
        logsType={logsType}
        isLoading={isLoading}
        dateRange={dateRange}
        total={total}
        onSearched={handleSearched}
        onDateChanged={handleDateChanged}
        onFocusChanged={handleFocusChanged}
        onSorted={handleSorted}
        onSizeChanged={handleSizeChanged}
        onPageChanged={handlePageChanged}
      />
    </div>
  )
}

export default SidebarContainer(RoutesModules.ADMIN)(Logs)



// WEBPACK FOOTER //
// ./src/modules/UserSettings/Logs/Logs.tsx